module.exports = __webpack_public_path__ + "img/sixpackcarrier71.3a376e14.jpg";